import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.9518 16.1331C31.857 15.9098 31.6378 15.7647 31.3949 15.7647H24.0152L20.548 8.3489C20.4485 8.1359 20.2349 8 20 8C19.7651 8 19.5515 8.1359 19.452 8.3489L15.9848 15.7647H8.60506C8.36222 15.7647 8.14302 15.9098 8.04818 16.1331C7.95335 16.3565 8.00092 16.615 8.1696 16.7899L13.6344 22.4574L11.4367 31.2481C11.3779 31.4833 11.4651 31.7309 11.6583 31.8771C11.8515 32.0233 12.1136 32.0402 12.3239 31.9202L20 27.5337L27.6761 31.9202C27.7695 31.9737 27.8729 32 27.9762 32C28.1054 32 28.2342 31.9586 28.3417 31.8771C28.5349 31.7309 28.622 31.4833 28.5633 31.2481L26.3656 22.4574L31.8304 16.7899C31.9991 16.615 32.0466 16.3565 31.9518 16.1331Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
